/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CustomerOrderDetUpdateModel { 
    guid?: string;
    customerOrderDetId?: number;
    customerOrderId?: number;
    itemNumber?: string | null;
    description?: string | null;
    quantity?: number;
    uOfM?: string | null;
    unitPrice?: number;
    amount?: number;
    isPriceOverwrite?: boolean;
    notes?: string | null;
    userId?: number;
    statusId?: number;
    isUpdateRequired?: boolean;
}

